import React, {useCallback, useEffect, useState} from "react";
import {Button, Typography} from "@mui/material";
import ModalComp from "@contents/components/ModalComp";
import {Strings} from "@app/constants/strings";
import {AlertDetail} from "@app/events";
import {FlexBox} from "@contents/components/customStyledComponent";

const EAlert = () => {

    const [isAlert, setIsAlert] = useState<boolean>(false);
    const [alertData, setAlertData] = useState<AlertDetail | null>(null);

    const handler = useCallback(({detail}: CustomEvent<AlertDetail>) => {
        setAlertData(detail);
        setIsAlert(true);
    }, []);

    useEffect(() => {
        window.addEventListener("eAlert", handler as any);

        return () => {
            window.removeEventListener("eAlert", handler as any);
        };
    }, []);


    const onClose = () => {
        setIsAlert(false);
        setAlertData(null);
    }

    const onPositive = async () => {
        if(alertData != null && alertData.callback != null) {
            const result = await alertData.callback();
            (result === undefined || result === true) && onClose();
        }
    }

    return (
        isAlert &&
        <ModalComp
            open={isAlert}
            onClose={onClose}
            title={alertData?.title ?? Strings.alarm}
            sx={{
                '& .MuiPaper-root': {
                    maxWidth: 300,
                },
                '& .modalWidth': {
                    minWidth: '300px',
                },
            }}
            disableEscapeKeyDown
            disableBackdropClick
            hideBackdrop
            buttonComponent={
                <>
                    {(alertData && alertData.type === 'CONFIRM') ?
                        <>
                            <Button variant={'contained'} color={'eliga_6FA'}
                                    onClick={onClose}>{Strings.cancel}</Button>
                            <Button variant={'contained'} color={'eliga_7FF'}
                                    onClick={onPositive}>{alertData?.confirmBtnTxt ?? Strings.confirm}</Button>
                        </>
                        : <Button variant={'contained'} color={'eliga_7FF'} onClick={onClose}>{Strings.confirm}</Button>
                    }

                </>
            }
        >
            <FlexBox $column gap="10px" sx={{whiteSpace: "break-spaces", maxWidth: 300}}>
                <Typography variant={'body1'} color={'eliga_399.main'}>{alertData?.message}</Typography>
                {alertData?.caption && <Typography variant="caption">{alertData?.caption}</Typography>}
            </FlexBox>
        </ModalComp>
    )
}

export default EAlert;
